module.exports = __webpack_public_path__ + "static/project-main-eras-554dd3bfd0879a14180dbb84faa7bf8f.jpg";